"use strict";

/*
 * Bilder gross anzeigen: Einzelbild und die alte Kachelgalerie.
 *
 * Am 2026-08-31 von jQuery auf natives JavaScript umgeschrieben. Der groesste
 * Teil war schon vorher natives JS - jQuery diente nur zum Auswaehlen und zum
 * Anhaengen der Klicks.
 *
 * Bedient wird das Markup aus:
 *   Partials/ContentElements/Media/Type/Image.html      (.js-open-modal-image)
 *   Partials/ContentElements/Media/Type/ImageGal.html   (.js-open-modal-gallery-image)
 *   Partials/ContentElements/Media/Gallery.html         (.bwSlides, Vorschaubilder)
 *
 * Nicht zu verwechseln mit der neuen Bildergalerie: die liegt in
 * Public/JavaScript/galerie.js, benutzt <dialog> und hat nie jQuery gebraucht.
 */

document.addEventListener("DOMContentLoaded", () => {
    let slideIndex = 1;

    document.querySelectorAll(".js-open-modal-image").forEach((el) => {
        el.addEventListener("click", (e) => {
            const fenster = document.getElementById("myModal" + e.currentTarget.dataset.uid);
            if (fenster) {
                fenster.style.display = "block";
            }
        });
    });

    document.querySelectorAll(".js-open-modal-gallery-image").forEach((el) => {
        el.addEventListener("click", (e) => {
            const aktuell = e.currentTarget.closest(".js-current-slide");
            if (aktuell) {
                slideIndex = aktuell.dataset.currentslide;
            }

            const galerie = e.currentTarget.closest(".bwgallery");
            if (!galerie) {
                return;
            }
            const fenster = document.getElementById("bwModal" + galerie.dataset.modalid);
            if (fenster) {
                fenster.style.display = "block";
            }
        });
    });

    document.querySelectorAll(".js-close-modal").forEach((el) => {
        el.addEventListener("click", (e) => {
            const eltern = e.currentTarget.parentElement;
            if (eltern) {
                eltern.style.display = "none";
            }
        });
    });

    const showSlides = (n) => {
        const slides = document.getElementsByClassName("bwSlides");
        const dots = document.getElementsByClassName("demo");
        const captionText = document.getElementById("caption");

        if (slides.length === 0) {
            return;
        }

        // n kommt teils als Zeichenkette aus dem data-Attribut.
        slideIndex = Number(n);
        if (slideIndex > slides.length) {
            slideIndex = 1;
        }
        if (slideIndex < 1) {
            slideIndex = slides.length;
        }

        for (let i = 0; i < slides.length; i++) {
            slides[i].style.display = "none";
        }
        for (let i = 0; i < dots.length; i++) {
            dots[i].className = dots[i].className.replace(" active", "");
        }

        slides[slideIndex - 1].style.display = "block";
        if (dots[slideIndex - 1]) {
            dots[slideIndex - 1].className += " active";
            if (captionText) {
                captionText.innerHTML = dots[slideIndex - 1].alt;
            }
        }
    };

    document.querySelectorAll(".js-next-pic").forEach((el) => {
        el.addEventListener("click", () => showSlides(Number(slideIndex) + 1));
    });

    document.querySelectorAll(".js-prev-pic").forEach((el) => {
        el.addEventListener("click", () => showSlides(Number(slideIndex) - 1));
    });

    document.querySelectorAll(".js-current-slide").forEach((el) => {
        el.addEventListener("click", (e) => showSlides(e.currentTarget.dataset.currentslide));
    });

    /*
     * Die Vorschaubildzeile waechst in Schritten von 100 Prozent nach links.
     * Wie viele Bilder nebeneinander stehen, haengt an der Fensterbreite - die
     * Schwellen entsprechen den Bootstrap-Punkten.
     */
    let move = 0;

    const slideMovement = () => {
        document.querySelectorAll(".thumbnail-container .column").forEach((spalte) => {
            spalte.style.transform = "translateX(" + move + "%)";
        });
    };

    const sichtbareBilder = () => {
        const breite = document.documentElement.clientWidth;
        if (breite < 768) {
            return 2;
        }
        if (breite < 810) {
            return 3;
        }
        if (breite < 992) {
            return 4;
        }
        if (breite < 1200) {
            return 5;
        }
        return 6;
    };

    document.querySelectorAll(".js-thumbnail-slide-next").forEach((el) => {
        el.addEventListener("click", () => {
            const behaelter = document.querySelector(".thumbnail-container");
            if (!behaelter) {
                return;
            }
            const anzahl = behaelter.childElementCount;
            const grenze = -(anzahl - sichtbareBilder()) * 100;

            if (move > grenze) {
                move -= 100;
                slideMovement();
            }
        });
    });

    document.querySelectorAll(".js-thumbnail-slide-prev").forEach((el) => {
        el.addEventListener("click", () => {
            if (move < 0) {
                move += 100;
                slideMovement();
            }
        });
    });
});
